export default __webpack_public_path__ + "static/media/partners-header.c357df62.jpg";